export default __webpack_public_path__ + "static/media/like.df376d27.svg";